var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{staticClass:"tb-success tb-active-danger",attrs:{"value":_vm.value,"width":90,"sync":true,"color":_vm.colors,"labels":_vm.labels},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }